<div #graphdiv *ngIf="showGraph" class="shadow-none graph">
  <ngx-graph #graph class="graph" [links]="links" [nodes]="nodes" [curve]="curve" [layout]="layout"
    [layoutSettings]="layoutSettings" [view]="[800, 2100]" [enableZoom]="false" [autoZoom]="false" [autoCenter]="false"
    [draggingEnabled]="false" [panningEnabled]="false" [showMiniMap]="false" [panOffsetX]="panOffsetX"
    [panOffsetY]="panOffsetY" [panToNode$]="panToNode$" [enableTrackpadSupport]="false">
    <ng-template #defsTemplate>
      <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="3" orient="auto">
        <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
      </svg:marker>
    </ng-template>

    <ng-template #nodeTemplate let-node>
      <svg:g class="node" xmlns="http://www.w3.org/2000/xhtml" [attr.width]="node.dimension.width"
        [attr.height]="node.dimension.height">
        <svg:foreignObject [attr.width]="node.dimension.width" [attr.height]="node.dimension.height">
          <xhtml:div xmlns="http://www.w3.org/1999/xhtml">
            <app-department-role [role]="node.data" [practiceId]="practiceId" [departmentId]="departmentId"
              [isMyCareer]="isMyCareer" [departmentName]="departmentName"
              [practiceName]="practiceName"></app-department-role>
          </xhtml:div>
        </svg:foreignObject>
      </svg:g>
    </ng-template>

    <ng-template #linkTemplate let-link>
      <svg:g class="edge">
        <svg:path class="line" stroke-width="2" marker-end="url(#arrow)"></svg:path>
      </svg:g>
    </ng-template>
  </ngx-graph>
</div>